const Languages = require('./config/languages');
const Users = require('./config/users');
const CmsUsage = require('./config/cms-usage');
const OfferFieldTags = require('./config/offer-field-tags');
const Schemas = require('./config/schemas');

const RequestProcess = require('./request/process');
const RequestProcessStep = require('./request/processstep');
const RequestForm = require('./request/form');
const RequestFormField = require('./request/formfield');
const RequestPackage = require('./request/package');
const RequestPackageStep = require('./request/packagestep');
const RequestHelper = require('./request/helper');

module.exports = {
	Config: {
		Languages,
		Users,
		Schemas,
		OfferFieldTags,
		CmsUsage
	},
	Request: {
		RequestProcess,
		RequestProcessStep,
		RequestForm,
		RequestFormField,
		RequestPackage,
		RequestPackageStep,
		RequestHelper,
		RequestConstants: {
			TYPE_INS: 'type_ins',
			TYPE_ASO: 'type_aso',
			TYPE_LOWHATCH: 'type_lowhatch',
			TYPE_RESTRICTEDVET: 'type_restrictedvet'
		}
	}
};
